// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"AhyLNl8865DQjgyscJ467"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://c4ce349bb309c750ba6f46d555c4afd2@o1165724.ingest.us.sentry.io/4508821956460544",

    integrations: [Sentry.replayIntegration()],

    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    beforeSend(event) {
      if (event.level !== 'error') {
        return null;
      }

      if (event.message?.includes('ResizeObserver loop limit exceeded')) {
        return null;
      }

      if (
        event.message?.includes('API Error: 401') ||
        event.exception?.values?.some(
          ex => ex.value?.includes('API Error: 401')
        )
      ) {
        return null;
      }

      return event;
    },

    debug: false,
  });
}
